/* eslint-disable no-multi-assign */
/* eslint-disable consistent-this */
(function($, window) {
	'use strict';

	function max(numberArray){
		return Math.max.apply(Math, [].slice.call(numberArray));
	}

	function total(items){
		var num = 0;
		$.each(items, function(index, item){
			num = num + $(item).outerWidth(true);
		});
		return num;
	}

	function func(methodName){
		var args = [].slice.call(arguments, 1);
		return function(index, element){
			return $.fn[methodName].apply($(element), args);
		};
	}

	function getPageGroups($listItems, maxWidth){
		var pages = [],
			page = 0,
			pageWidth = 0;

		$listItems.each(function(index, item){
			var $item = $(item),
				itemWidth = $item.outerWidth(true),
				combinedWidth = pageWidth + itemWidth;

			if(combinedWidth > maxWidth){
				pageWidth = 0;
				page++;
				combinedWidth = pageWidth + itemWidth;		
			}

			if(!pages[page]){
				pages[page] = [];
			}			

			pages[page].push($item);
			pageWidth = combinedWidth;
		});

		return pages;		
	}	

	function VariableItemWidthCarousel(element, options) {
		var defaults = {
			easing: 'swing',
			speed: 350,
			updateTimer: 200
		}, 
		self = this,
		opts = this.options = $.extend(defaults, options || {});

		this.$list = $(element).addClass('viwc-list')
.wrap('<div class="viwc-wrapper" />');
		this.$wrapper = this.$list.parent('.viwc-wrapper');
		this.currentPage = 0;
		this.initialized = false;
		
		this.$list
			.on('nextPage', $.proxy(this.nextPage, this))
			.on('prevPage', $.proxy(this.prevPage, this))
			.on('pageChange', $.proxy(this.setNavigation, this));

		if(!(opts.next && opts.next.length && opts.prev && opts.prev.length)){
			opts.next = $('<button class="viwc-next" aria-label="Next">Next</button>').appendTo(this.$wrapper);
			opts.prev = $('<button class="viwc-prev" aria-label="Previous">Prev</button>').prependTo(this.$wrapper);
		}

		opts.next.hide().on('click', function(e){
			e.preventDefault();
			self.$list.trigger('nextPage');
		});	

		opts.prev.hide().on('click', function(e){
			e.preventDefault();
			self.$list.trigger('prevPage');
		});	

		$(window).on('resize', function(){
			if(self.timer){
				clearTimeout(self.timer);
			}

			self.timer = setTimeout(function(){
				self.update();
				self.timer = null;
			}, self.options.updateTimer);
		});	

		this.update();
	}

	VariableItemWidthCarousel.prototype = {
		update: function(forceReset) {
			this.$items = this.$list.find('> li:not(.viwc-spacer)');
			this.getDimensions();

			if(this.initialized){
				this.$current = this.pages[this.currentPage][0];			
			}

			this.getPages();
			this.addPageNumberData();
			this.addSpacers();
			this.setDimensions();

			if(this.initialized && !forceReset){
				this.resetToCurrentPage();
			}

			this.initialized = true;
			this.setNavigation();
		},
		resetToCurrentPage: function(){
			var data = this.$current.data('page');
			if(typeof data !== 'undefined'){
				this.currentPage = data;
				this.$list.css('left', -(this.currentPage * this.width) + 'px');					
			}
		},
		getPages: function(){
			if(this.maxWidth < this.width){
				this.pages = getPageGroups(this.$items, this.width);
			}else{
				this.width = this.maxWidth;
				this.pages = [];
				this.$items.each(function(index, item){
					this.pages.push([$(item)]);
				}.bind(this));
			}
		},
		getPageCount: function(){
			return this.pages.length;
		},
		getDimensions: function(){
			this.width = this.$wrapper.width();
			this.maxHeight = max(this.$items.map(func('outerHeight', true)));
			this.maxWidth = max(this.$items.map(func('outerWidth', true)));
		},
		setDimensions: function(){
			var combinedItemWidth = total(this.$items) * 2;
			this.$wrapper.css('height', this.maxHeight + 'px');
			this.$list.css('width', combinedItemWidth < this.width ? 'auto' : combinedItemWidth);
		},
		addPageNumberData: function(){
			$.each(this.pages, function(pageIndex, page){
				$.each(page, function(index, $item){					
					$item.data('page', pageIndex);
				});
			});
		},
		addSpacers: function(){
			var self = this;
			this.$wrapper.find('.viwc-spacer').remove();
			$(this.pages).each(function(index, page){
				var pageWidth = total(page),
					diff = self.width - pageWidth;

				if(diff > 0){
					$('<li class="viwc-spacer" />').insertAfter(page[page.length - 1])
.css({
						width: diff + 'px',
						height: self.maxHeight + 'px'
					});						
				}	
			});
		},
		hasPages: function(){
			return this.pages.length > 1;
		},
		gotoPage: function(pageNumber){
			if(pageNumber >= 0 && pageNumber !== this.pages.length){
				var direction = pageNumber < this.currentPage ? -1 : 1,
					diff = Math.abs(this.currentPage - pageNumber),
					left = this.width * direction * diff;

				this.$list.filter(':not(:animated)').animate({
					'left': '-=' + left + 'px'
				}, this.options.speed, this.options.easing, function() {
					this.currentPage = pageNumber;
					this.$list.trigger('pageChange');
				}.bind(this));
			}
		},
		nextPage: function(){
			this.gotoPage(this.currentPage + 1);
		},
		prevPage: function(){
			this.gotoPage(this.currentPage - 1);
		},
		isFirstPage: function(){
			return this.currentPage === 0;
		},
		isLastPage: function(){
			return this.currentPage === this.pages.length - 1;
		},
		reset: function(){
			this.$list.css('left', 0);
			this.currentPage = 0;
			this.update(true);
		},
		setNavigation: function(){
			this.options.next[this.hasPages() && !this.isLastPage() ? 'show' : 'hide']();
			this.options.prev[this.hasPages() && !this.isFirstPage() ? 'show' : 'hide']();
		}
	};

	$.fn.variableItemWidthCarousel = function(options){
		return this.each(function(index, item){
			var $this = $(item);

			if(!$this.find('> li').length){
				return;
			}

			if(!$this.data('variableItemWidthCarousel')){
				$this.data('variableItemWidthCarousel', new VariableItemWidthCarousel($this, options));
			}		
		});
	};
})(jQuery, window);
